var makeString = require('./helper/makeString');
var slice = [].slice;

module.exports = function join() {
  var args = slice.call(arguments),
    separator = args.shift();

  return args.join(makeString(separator));
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/join.js
// module id = 430
// module chunks = 0